import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import { Button, Link, I18n, Status } from 'components';
import { formatDateString } from 'utils/formatString';
import AbstractService, { cx, Description } from '../AbstractService';

// Utils
import { partnerServiceDisconnectedSuccessYM } from '../../../../utils/analytics/partnerServiceDisconnectedSuccessYM';

/**
 * Format Date object to view format
 * @param {Date} input
 * @return {String}
 */
function formatDate(input) {
  return formatDateString(input, 'DD.MM.YYYY');
}

class Subscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDisconnectionFormOpened: false,
      isDisconnecting: false,
      requestId: null,
      error: false,
      isLoading: false,
    };
  }

  toggleDisconnectionForm = () => {
    this.setState((prevState) => ({
      isDisconnectionFormOpened: !prevState.isDisconnectionFormOpened,
    }));
  };

  disconnectSubscription = () => {
    const {
      subscriptionId,
      subscriptionType,
      actions,
      title,
    } = this.props;

    this.setState({ isDisconnecting: true, isLoading: true, error: false });

    const errorPayload = {
      requestId: null,
      error: true,
      isLoading: false,
    };

    actions.disconnectSubscription(subscriptionId, subscriptionType)
      .then(
        (data) => (data.isSuccess ? { requestId: data.requestId, error: false } : errorPayload),
        () => errorPayload,
      )
      .then((payload) => (
        this.setState({
          ...payload,
          isDisconnecting: false,
        })
      ));

    if (this.state.isDisconnecting && subscriptionType === 'PartnerService') {
      partnerServiceDisconnectedSuccessYM(title);
    }
  };

  render() {
    const {
      rate,
      priceDescription,
      priceNote,
      title,
      provider,
      subscriptionId,
      ratePeriod,
      description,
      futurePriceDate,
      productParameters,
      isActive,
      enabled,
      isPartner,
      subscriptionType,
    } = this.props;
    const {
      requestId,
      isDisconnecting,
      isDisconnectionFormOpened,
      error,
      isLoading,
    } = this.state;

    const isPartnerType = (subscriptionType === 'PartnerService' && !isPartner);
    const isSwitchCheckedPartner = isPartnerType && isActive && !isDisconnectionFormOpened && !requestId;

    const isSwitchChecked = (!isDisconnectionFormOpened && !requestId);
    const isSwitchDisabled = ((isPartnerType && !enabled) || !subscriptionId || Boolean(requestId)
       || isDisconnecting || isLoading);
    const isButtonShown = (isDisconnectionFormOpened && !requestId);

    return (
      <AbstractService
        checked={isPartnerType ? isSwitchCheckedPartner : isSwitchChecked}
        disabled={isSwitchDisabled}
        onChange={this.toggleDisconnectionForm}
        title={title}
        rate={rate}
        priceNote={priceNote}
        priceDescription={priceDescription}
        ratePeriod={ratePeriod}
        currency="₽"
        isLoading={isLoading || Boolean(requestId)}
        productParameters={productParameters}
      >
        {provider && (
          <div className={cx('description')}>
            {`Оказывается с привлечением провайдера ${provider}`}
          </div>
        )}

        {requestId && (
          <div className={cx('response')}>
            <I18n path="services.subscriptionsDisconnectMessage" />
          </div>
        )}

        <Description html={description} />

        {Date.now() < futurePriceDate && !priceDescription && (
          <Status className={['wide', 'attention', cx('status')]}>
            <I18n
              path="services.futurePriceMessage"
              vars={{
                date: formatDate(futurePriceDate),
              }}
            />
          </Status>
        )}

        {isButtonShown && (
          <Status className={cx('disconnectionForm')}>
            <div className={cx('disconnectionFormTitle')}>
              Вы действительно хотите отключить подписку?
            </div>
            <Button
              className="default"
              onClick={this.disconnectSubscription}
              isLoading={isDisconnecting}
            >
              Подтвердить
            </Button>
            <Link
              className={cx('disconnectionLink')}
              onClick={this.toggleDisconnectionForm}
            >
              Отменить
            </Link>
          </Status>
        )}

        {!!error && (
          <Status className="error">
            {error && (
              <I18n path="services.errorMessage" />
            )}
          </Status>
        )}
      </AbstractService>
    );
  }
}

Subscription.defaultProps = {
  description: null,
  futurePriceDate: null,
};

Subscription.propTypes = {
  actions: PropTypes.object.isRequired,
  description: PropTypes.string,
  rate: PropTypes.number,
  priceDescription: PropTypes.string,
  priceNote: PropTypes.string,
  ratePeriod: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subscriptionId: PropTypes.string,
  subscriptionType: PropTypes.string.isRequired,
  title: PropTypes.string,
  provider: PropTypes.string,
  futurePriceDate: PropTypes.objectOf(Date),
  isRestrictedAccess: PropTypes.bool,
  productParameters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  isActive: PropTypes.bool,
  enabled: PropTypes.bool,
  isPartner: PropTypes.bool,
};

export default Subscription;
